export default __webpack_public_path__ + "static/media/parkeasy1.2a6d4a03.png";